import { create } from 'zustand';
import { ApiUtils, FileEntity, FolderEntity, RequestStrategyEnum, ResourceEntity, ResourcesApi } from '@shared/api';

interface IRepositoryStore {
  loading: boolean;
  error: string | null;
  repository: ResourceEntity[];
  folder: FolderEntity[];
  getRepository: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRepositoryStore = create<IRepositoryStore>((set) => ({
  loading: false,
  error: null,
  repository: [],
  folder: [],

  getRepository: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ResourcesApi.getRepository(signal);

      const folderData = result.reduce((acc: { [key: string]: FileEntity[] }, item) => {
        const folderItem = acc[item.folder] || [];
        folderItem.push({
          name: item.file,
          fileName: item.file,
          fileTitle: item.file,
          id: item.id,
          applicationId: '',
          fileType: item.mimeType,
          dateUploaded: new Date().toString(),
        });
        acc[item.folder] = folderItem;
        return acc;
      }, {});
      const folder = Object.keys(folderData).map((folderName, idx) => ({
        folderName,
        folderId: idx,
        files: folderData[folderName],
      }));

      set({ repository: result ?? [], folder: folder ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ repository: [], loading: false, error: null }),
}));
